import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../../../components/buttons/buttons";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import TableFilter from "../../../../../components/tables/tableFilter";
import { PaginationNoRoute } from "../../../../../components/pagination/paginationNoRoute";
import EmptyState from "../../../../../assets/images/emptyState/payment.svg";
import { AllFiltersModal } from "../../../../../components/modals/allFiltersModal";
import { filterBusinessAction } from "../../../../../redux/business/businessActions";

export default function BusinessRevenueSettings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [isFilterOpen, setFilterState] = useState(false);

  const { allBusinesses, filtering } = useSelector((state) => state.business);

  const [payLoad] = useState({
    // management_approved: 1,
    end_date: new Date(),
  });

  useEffect(() => {
    dispatch(filterBusinessAction(payLoad, page));
  }, [dispatch, payLoad, page]);

  function createTableData(data) {
    if (Array.isArray(data)) {
      const outputArray = [];
      data.forEach((split, index) => {
        const single = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          businessName: split?.business_name,
          orderId: split?.order_id || "N/A",
          businessEmail: split?.business_email,
          location: split?.business_city,
          status: split?.is_split ? (
            <span className="inline-flex rounded-full px-2 py-1 text-xs font-semibold bg-green-100 text-green-800">
              Split
            </span>
          ) : (
            <span className="inline-flex rounded-full px-2 py-1 text-xs font-semibold bg-yellow-100 text-yellow-800">
              Pending
            </span>
          ),
          date: moment(split?.created_at).format("DD MMM YYYY"),
          split: split,
        };

        outputArray.push({ single });
      });

      return outputArray;
    }
    return [];
  }

  const data = useMemo(
    () => createTableData(allBusinesses?.data),
    [allBusinesses?.data],
  );

  const goToSplitPage = (params) => {
    const splitId = params?.single?.split?.id;
    navigate(`/admin/revenue/revenue-settings/business/${splitId}`);
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        columns: [
          {
            Header: "S/N",
            accessor: "single.num",
          },
          {
            Header: "Business Name",
            accessor: "single.businessName",
          },
          {
            Header: "Email",
            accessor: "single.businessEmail",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
          // {
          //   Header: "Revenue Status",
          //   accessor: "single.status",
          // },
        ],
      },
    ],
    [],
  );

  return (
    <div>
      <TableFilter
        title={"Revenue Settings"}
        // results={allFood?.to}
        // totalResults={allFood?.total}
        // onChange={handleChange}
        // handleKeyDown={handleKeyDown}
        searchPlaceholder={"Search Business name, email, phone number "}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            {/* <FilterFoodDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            /> */}
          </AllFiltersModal>
        }
      >
        <Button.Secondary
          // title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          title={"Download CSV"}
          type="button"
          disabled={!data}
          // onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3] dark:border-[#505050]"></div>

      {filtering ? (
        <TableSkeleton />
      ) : (
        <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
          {data?.length > 0 ? (
            <Table
              columns={columns}
              data={data}
              onClick={goToSplitPage}
              goToSinglePage={goToSplitPage}
            />
          ) : (
            <div className="text-center py-12">
              <img
                src={EmptyState}
                alt="empty"
                className="w-32 h-32 mx-auto mb-4"
              />
              <p className="text-gray-500 dark:text-gray-400">
                No business revenue settings found
              </p>
            </div>
          )}

          <PaginationNoRoute
            data={allBusinesses}
            page={page}
            setPage={setPage}
          />
        </div>
      )}
    </div>
  );
}
